import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "measurement-list" }

import { computed } from 'vue'
import { useMeasurementStore } from '@/store/measurementStore'
import { storeToRefs } from 'pinia'
import MeasurementListItem from '@/components/measurement/MeasurementListItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementList',
  setup(__props) {

const measurementStore = useMeasurementStore()
const { measurements } = storeToRefs(measurementStore)

const measurementsList = computed(() => {
  if (measurements.value.length <= 1) {
    return measurements.value
  }

  return measurements.value.slice(0, -1)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measurementsList.value, (item, i) => {
      return (_openBlock(), _createBlock(MeasurementListItem, {
        key: i,
        index: i,
        measurement: item
      }, null, 8, ["index", "measurement"]))
    }), 128))
  ]))
}
}

})